/**
    * A function to turn a number into a number WITH commas.
    * @param targetNumber `string | number` - Number to apply commas to.
    * @returns Number that was applied with commas attached.
    * @example NumberWithCommas(51000);
*/
export const NumberWithCommas = (targetNumber: string | number) => {
    targetNumber = targetNumber.toString();

    // ADD COMMAS
    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(targetNumber)) targetNumber = targetNumber.replace(pattern, "$1,$2");

    // RETURN NUMBER WITH COMMAS
    return targetNumber;
}

/**
    * A function to filter an array of objects to ones that match a provided keyword
    * @param query `string` - The keyword to find in a value
    * @param data `object[]` - The data to filter through. 
    * @returns `object[]` - The array of objects reduced to those that match the provided keyword. 
    * @example FilterEntriesBySearch('Hey', [{'greeting': 'Hey there'}, {'greeting': 'Hey Steve!'}]);
*/
export const FilterEntriesBySearch = (query: string, data: object[]) => {
    if (!query) {
        return data;
    } else {
        const lowercasedQuery = query.toLowerCase();
        return data.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(lowercasedQuery)));
    }
}
